import { render } from "./AppDropdownServings.vue?vue&type=template&id=16abd922&scoped=true"
import script from "./AppDropdownServings.vue?vue&type=script&lang=js"
export * from "./AppDropdownServings.vue?vue&type=script&lang=js"

import "./AppDropdownServings.vue?vue&type=style&index=0&id=16abd922&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16abd922"]])

export default __exports__